"use strict";

exports.__esModule = true;
exports.default = void 0;

var _formRow = require("../layout/form-row");

var _default = _formRow.default;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/form/form-row.js
// module id = I7Xz
// module chunks = 1